module.exports = __webpack_public_path__ + "img/c02.fb9c719c.png";